/*eslint no-unreachable: "error"*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Arrow from '@/assets/images/icons/Arrow.vue';
import Building from '@/assets/images/icons/Building.vue';
import Calendar from '@/assets/images/icons/Calendar.vue';
import Checkmark from '@/assets/images/icons/Checkmark.vue';
import ChevronDown from '@/assets/images/icons/ChevronDown.vue';
import Pencil from '@/assets/images/icons/Pencil.vue';

Vue.config.productionTip = false;
Vue.component('Arrow', Arrow);
Vue.component('Building', Building);
Vue.component('Calendar', Calendar);
Vue.component('Checkmark', Checkmark);
Vue.component('ChevronDown', ChevronDown);
Vue.component('Pencil', Pencil);

new Vue({
  router,
  render: h => h(App),
  data: {
    type: 'apartment',
    heater_type: null,
    estimated: false,
    direct_watts: 6000,
    people: 2,
    surface: 100,
    price_type: 'variable',
    commitment: 1,
    asap: true,
    start: null,
    barncancerfonden: false,
    miljoval: false,
    prisbevakning: false,
    prisbevakning_option: 35,
    personnummer: null,
    name: null,
    surname: null,
    address: null,
    postal_code: null,
    location: null,
    phone: null,
    email: null,
    email_confirm: null,
    another_address: false,
    other_address: null,
    other_postal_code: null,
    other_location: null,
    construction_id: null,
    territory_id: null,
    acknowledgement: null,
    terms: false,
  },
  watch: {
    type(n) {
      let direct_watts = 6000;
      let people = 2;
      let surface = 100;
      switch(n) {
        case 'apartment':
          direct_watts = 2000;
          people = 2;
          surface = 80;
        break;
        case 'house':
          direct_watts = 5000;
          people = 3;
          surface = 120;
        break;
        case 'big_house':
          direct_watts = 20000;
          people = 4;
          surface = 200;
        break;
      }
      this.direct_watts = direct_watts;
      this.people = people;
      this.surface = surface;
    },
  },
  computed: {
    watts() {
      return this.estimated ? this.people * this.surface * 10 : this.direct_watts;
    },
    fixed_price() {
      return Math.round(this.watts / 1.11 / 120 * ((100-this.commitment + 1) / 100));
    },
    variable_price() {
      return Math.round(this.watts / 1.11 / 120 * 1.3 * ((100-this.commitment + 1) / 100));
    },
    moms() {
      return this.net_price * .25;
    },
    net_price() {
      return this.price_type === 'fixed' ? this.fixed_price : this.variable_price;
    },
    price() {
      return this.net_price + this.moms;
    },
    final_price() {
      let price = this.price;
      if (this.barncancerfonden) {
        price += 25;
      }
      if (this.miljoval) {
        price += 10;
      }
      if (this.prisbevakning) {
        price += this.prisbevakning_option;
      }
      return Math.round(price * 12);
    },
    step() {
      let step = 1;
      switch(this.$route.name) {
        case 'elpris':
          step = 2;
          break;
        case 'uppgifter':
        case 'uppgifter2':
          step = 3;
          break;
        case 'bekrafta':
          step = 4;
          break;
      }
      return step;
    },
  },
  methods: {
    send() {
      alert('SENT!!');
    },
  }
}).$mount("#app");
